'use es6';

import { enableMapSet } from 'immer';
import { enableTransmute } from 'immutable-less';
import App from './App';
enableMapSet();
enableTransmute();
new App().start();